<template>
  <div id="shop" class="shop">
    <article>
        <section>
            <shop-hero :images="images" :spaceBetween="20"></shop-hero>
        </section>
    </article>
    <article>
      <product></product>
      <section class="section-max-width">
          <div class="container msf-sweden">
              <div class="row">
                  <p>10 % of your purchase is donated to <span class="no-break">Médecins Sans Frontières</span>, <span class="no-break">Doctors Without Borders</span></p>
              </div> 
          </div>
      </section> 
      <related-products></related-products>
    </article>
  </div>
</template>

<script>
import shopHero from '@/components/hero/ShopHero.vue'
import product from '@/components/shop/Product.vue'
import relatedProducts from '@/components/shop/RelatedProducts.vue'

export default {
  name: "shop",
  components: {
    shopHero,
    product,
    relatedProducts
  },
  data() {
    return {
      images: [],
      imagesDesktop: [
        'shop-slider-1-20181122.jpg', 
        'shop-slider-2-20181116.jpg', 
        'shop-slider-3-20181116.jpg',
        'shop-slider-4-20181116.jpg',
        'shop-slider-5-20181116.jpg',
      ],
      imagesMobile: [
        'mobile-shop-slider-1-20181119.jpg', 
        'mobile-shop-slider-2-20181119.jpg', 
        'mobile-shop-slider-3-20181119.jpg',
        'mobile-shop-slider-4-20181116.jpg',
        'mobile-shop-slider-5-20181119.jpg',
      ]
    }
  },
   created () {
    if (window.innerWidth <= 780) {
      this.images = this.imagesMobile;
    }
    else {
      this.images = this.imagesDesktop;
    }
  }
}
</script>

<style lang="postcss" scoped>

.no-break {
  display: inline-block;
}

.shop {
  padding-top: 50px;
}
.container {
  padding-top: 50px;
  padding-bottom: 50px; 
  background:#787878;

}
.msf-sweden {
  flex-flow: row wrap;
  box-sizing: border-box;

}

.msf-sweden .row {

  display: flex;
  flex-flow: row wrap;
  justify-content: center;

}

.msf-sweden img {
  display: block;
  width: 200px;
  height: 80px; 
}

.msf-sweden div p { 
  font-size: 1.6em; 
  margin: 0;
  line-height: 4em;
  padding: 0 1em;
  text-align: center;
  font-family: Didot-Italic;
  color: #fff;
}

@media screen and (max-width: 780px) {
    .container {
    margin-top: 20%;
    margin-bottom: 10%;
  }
  
  .msf-sweden div p {
    line-height: 1.4em; 
    font-size: 1.2em;
      padding-top: 10%; 
      padding-bottom: 10%;
  }

    .msf-sweden img {
    width: 150px;
    height: 60px;
    object-fit: scale-down;
    padding-bottom: 10%;
  }
}
</style>